/**
 * Os links compartilháveis do social, num lugar só.
 *
 * POR QUE ISTO EXISTE: havia DOIS formatos de link de perfil no app, gerados
 * em arquivos diferentes, e um deles não funcionava.
 *
 *   `UserProfileOffcanvas` gerava `https://www.lesvita.com/app/perfil?id={uid}`
 *   — que é real: `/app/:destino` cai no `DeepLinkRoute`, e `perfil` está no
 *   mapa de `deepLinkRoutes` com o parâmetro `perfilUid`.
 *
 *   `OffcanvasAddAmigos` gerava `https://lesvita.com/u/{uid}` — que NÃO existe:
 *   `/u/{uid}` são dois segmentos e o curinga do roteador (`/:referralCode`)
 *   só casa com um. Era o endereço que ia no QR e no botão de compartilhar do
 *   perfil, ou seja, o link que mais circulava era o quebrado.
 *
 * Agora os dois importam daqui. Mudar o formato passa a ser uma linha, e não
 * uma caçada por `lesvita.com` no `src` inteiro.
 */

/** Origem canônica. Com `www`: é a que responde sem redirecionar. */
export const BASE = 'https://www.lesvita.com';

/**
 * Link de DEEP LINK do perfil — o que abre o app direto.
 *
 * Usado onde quem recebe quase certamente TEM o app: o QR do perfil, lido de
 * aparelho para aparelho. `/app/*` está no Universal Link e no App Links, então
 * o sistema entrega ao app sem passar pelo navegador. Para compartilhar com o
 * mundo, use `linkPublicoDoPerfil`: este aqui cai numa tela de login para quem
 * não tem conta.
 */
export function linkDoPerfil(uid) {
  if (!uid) return BASE;
  return `${BASE}/app/perfil?id=${encodeURIComponent(uid)}`;
}

/**
 * Link para um post.
 *
 * Mesmo trilho `/app/*` do perfil, pelo mesmo motivo: é o caminho que já tem
 * Universal Link configurado nas duas lojas.
 */
export function linkDoPost(postId) {
  if (!postId) return BASE;
  return `${BASE}/app/post?id=${encodeURIComponent(postId)}`;
}

/**
 * Link PÚBLICO do perfil — o que vai para fora do app.
 *
 * `/u/{uid}` é servido por Cloud Function com Open Graph de verdade (nome,
 * foto, nível), então a prévia no WhatsApp mostra a pessoa em vez do card
 * genérico de pré-lançamento. Abre para quem não tem conta, e leva ao app com
 * um toque.
 *
 * ESTE CAMINHO JÁ EXISTIU QUEBRADO: `OffcanvasAddAmigos` gerava `/u/{uid}`
 * quando nenhuma rota respondia por ele. Agora responde — e a diferença é que
 * há um servidor do outro lado.
 */
export function linkPublicoDoPerfil(uid) {
  if (!uid) return BASE;
  return `${BASE}/u/${encodeURIComponent(uid)}`;
}

/** Link público de um post, com a foto e a legenda na prévia. */
export function linkPublicoDoPost(postId) {
  if (!postId) return BASE;
  return `${BASE}/p/${encodeURIComponent(postId)}`;
}
